/*jshint esversion: 6 */
import {createApp} from 'vue';

import {
	createAnimation,
	IonicVue
} from '@ionic/vue';


import {Amplify} from 'aws-amplify';
import config from './amplifyconfiguration.json';
import {getRuntimeConfig} from './config/runtimeConfig';

Amplify.configure(config);

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables - copied from existing project */
import './theme/variables.css';

import './theme/quasar.prod.css';
import './theme/admin-glass.css';
import './theme/admin-theme-pass.css';
import './theme/skeleton.css';
import './theme/toast.css';

import './@fortawesome/fontawesome-pro/css/fontawesome.min.css';
import './@fortawesome/fontawesome-pro/css/light.min.css';
import './@fortawesome/fontawesome-pro/css/solid.min.css';
import './@fortawesome/fontawesome-pro/css/sharp-solid.min.css';
import './@fortawesome/fontawesome-pro/css/regular.min.css';
import './@fortawesome/fontawesome-pro/css/sharp-regular.min.css';
import './@home-icons/font/style.css'
import './@home-icons/font/icon-mappings.css'


import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';import LocalStorage from 'quasar/src/plugins/storage/LocalStorage.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import Quasar from 'quasar/src/vue-plugin.js';import TouchPan from 'quasar/src/directives/touch-pan/TouchPan.js';
import iconSet from 'quasar/icon-set/fontawesome-v6-pro'
// import quasarUserOptions from './quasar-user-options'

// import './registerServiceWorker';
import {createPinia} from 'pinia';
import i18n from './i18n';
import {SplashScreen} from '@capacitor/splash-screen';
import './registerServiceWorker.js'
import { initAnalytics } from './analytics';
import { installGlobalToastNormalization } from './utils/toast';

await SplashScreen.show({
	showDuration: 3500,
	//autoHide: true,
});

const runtimeConfig = getRuntimeConfig();
const activeTheme = runtimeConfig.organisation || 'fittr';

initAnalytics({
	appVersion: runtimeConfig.version,
	organisationTheme: activeTheme,
});

if (typeof document !== 'undefined') {
	document.documentElement.classList.add(activeTheme);
	document.body.classList.add(activeTheme);
}

function resolveThemeVar(themeClass, cssVar, fallback) {
	if (typeof document === 'undefined') {
		return fallback;
	}

	const probe = document.createElement('div');
	probe.className = themeClass;
	probe.style.position = 'fixed';
	probe.style.left = '-9999px';
	probe.style.top = '-9999px';
	probe.style.visibility = 'hidden';

	document.body.appendChild(probe);
	const value = getComputedStyle(probe).getPropertyValue(cssVar).trim();
	document.body.removeChild(probe);

	return value || fallback;
}

const quasarBrand = {
	primary: resolveThemeVar(activeTheme, '--ion-color-primary', '#4b4b5d'),
	secondary: resolveThemeVar(activeTheme, '--ion-color-secondary', '#d87c1f'),
	accent: resolveThemeVar(activeTheme, '--ion-color-medium', '#919199'),
	dark: resolveThemeVar(activeTheme, '--ion-color-dark', '#4b4b5d'),
	positive: resolveThemeVar(activeTheme, '--ion-color-success', '#248f48'),
	negative: resolveThemeVar(activeTheme, '--ion-color-danger', '#eb445a'),
	info: resolveThemeVar(activeTheme, '--ion-color-tertiary', '#f68d23'),
	warning: resolveThemeVar(activeTheme, '--ion-color-warning', '#00518b'),
};

function fittrPageTransition(baseEl, opts = {}) {
	if (!opts.enteringEl) {
		return createAnimation().addElement(baseEl).duration(0);
	}

	const prefersReducedMotion = typeof window !== 'undefined'
		&& window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const isBackDirection = opts.direction === 'back';
	const enterOffset = isBackDirection ? '-96px' : '96px';
	const leaveOffset = isBackDirection ? '96px' : '-96px';

	const enteringAnimation = createAnimation()
		.addElement(opts.enteringEl)
		.beforeStyles({'z-index': '2'})
		.afterClearStyles(['opacity', 'transform', 'z-index'])
		.fromTo('opacity', 0, 1);

	if (!prefersReducedMotion) {
		enteringAnimation.fromTo('transform', `translateX(${enterOffset})`, 'translateX(0)');
	}

	const leavingAnimation = opts.leavingEl
		? createAnimation()
			.addElement(opts.leavingEl)
			.beforeStyles({'z-index': '1'})
			.afterClearStyles(['opacity', 'transform', 'z-index'])
			.fromTo('opacity', 1, 0.92)
		: createAnimation();

	if (opts.leavingEl && !prefersReducedMotion) {
		leavingAnimation.fromTo('transform', 'translateX(0)', `translateX(${leaveOffset})`);
	}

	return createAnimation()
		.addElement(baseEl)
		.duration(prefersReducedMotion ? 120 : 240)
		.easing('cubic-bezier(0.2, 0, 0, 1)')
		.addAnimation([enteringAnimation, leavingAnimation]);
}

const [{ default: App }, { default: router }] = await Promise.all([
	import('./App.vue'),
	import('./router/index.js'),
]);

const app = createApp(App)
	.use(i18n)
	.use(createPinia())
	.use(Quasar, {
		config: {
			//brand: {
			//   primary: '#f39600',
			//   secondary: '#00518b',
			//   accent: '#feebd0',
			//   dark: '#1d1d1d',
			//   positive: '#21BA45',
			//   negative: '#C10015',
			//   info: '#31CCEC',
			//   warning: '#ff9966'
			//},
			brand: quasarBrand,
			notify: {
				position: 'center',
				classes: 'fittr-ios-toast fittr-ios-toast--warning',
				timeout: 2800
			},
		},
		directives: {
			TouchPan,
			ClosePopup
		},
		plugins: {
			Notify,
			LocalStorage,
		},
		framework: {cssAddon: true},
		iconSet: iconSet,
		// Fastclick:Fastclick
	})
	.use(IonicVue, {
		navAnimation: fittrPageTransition,
	})
	.use(router);

installGlobalToastNormalization(app.config.globalProperties.$q, Notify);

const resizeObserverMessage = 'ResizeObserver loop completed with undelivered notifications.';

if (typeof window !== 'undefined') {
	window.addEventListener('error', (event) => {
		if (event?.message === resizeObserverMessage) {
			event.stopImmediatePropagation();
			event.preventDefault();
		}
	}, true);
}

app.config.warnHandler = (msg, instance, trace) => {
	if (typeof msg === 'string' && msg.includes('Slot "default" invoked outside of the render function')) {
		return
	}
	// eslint-disable-next-line no-console
	console.warn(msg + (trace || ''))
}

router.isReady().then(() => {
	app.mount('#app');
});
